import React from "react";
import car1 from "../../Assets/Tour/car1.png";
import car2 from "../../Assets/Tour/car2.png";
import car3 from "../../Assets/Tour/car3.png";
import passenger from "../../Assets/Tour/passenger.png";
import gearShifting from "../../Assets/Tour/gearShifting.png";
import luggage from "../../Assets/Tour/luggages.png";
import door from "../../Assets/Tour/door.png";

const data = [
  {
    id: 1,
    img: car1,
    carName: "Toyota Innova",
    passengerCapacity: 7,
    gearType: "Manual",
    luggageCapacity: 4,
    noOfDoors: 4,
    aos: "fade-right"
  },

  {
    id: 2,
    img: car2,
    carName: "Toyota Innova",
    passengerCapacity: 7,
    gearType: "Manual",
    luggageCapacity: 4,
    noOfDoors: 4,
    aos: "flip-up"
  },

  {
    id: 3,
    img: car3,
    carName: "Force Motors",
    passengerCapacity: 9,
    gearType: "Manual",
    luggageCapacity: 8,
    noOfDoors: 4,
    aos: "fade-left"
  },
];

function VehicleService() {
  return (
    <div className="mx-4 my-8 flex flex-col items-center sm:mx-6 lg:mx-16">
      <h1
        className="mb-4 text-center text-3xl font-bold text-[#292929] tracking-wide sm:text-4xl"
        style={{ fontFamily: "DM Sans, sans-serif" }}
      >
        Vehicle Service
      </h1>
      <p
        className="mb-6 w-full max-w-2xl text-center text-sm text-[#666666] sm:mb-8 sm:text-base"
        style={{ fontFamily: "DM Sans, sans-serif" }}
      >
        We are providing vehicle service with a experienced driver and a guide,
        who can help you and can guide you with your every step
      </p>

      <div className="grid w-full grid-cols-1 items-start gap-8 sm:grid-cols-2 xl:grid-cols-3">
        {data.map((data) => (
          <div
            key={data.id}
            className="flex w-full min-w-0 flex-col"
            style={{ fontFamily: "DM Sans, sans-serif" }}
            data-aos={data.aos}
          >
            <img src={data.img} alt={data.carName} className="mb-4 max-h-64 w-full object-contain" />
            <h2 className="mb-4 text-xl font-bold sm:text-2xl">{data.carName}</h2>
            <div className="grid grid-cols-4 gap-2 sm:gap-3">
              <div className="flex min-w-0 flex-col items-center gap-2">
                <img src={passenger} alt="Passenger Capacity" className="h-8 w-8 object-contain" />
                <p className="text-[#555555] text-sm">
                  {data.passengerCapacity}
                </p>
              </div>
              <div className="flex min-w-0 flex-col items-center gap-2">
                <img src={gearShifting} alt="Gear Type" className="h-8 w-8 object-contain" />
                <p className="text-[#555555] text-sm">{data.gearType}</p>
              </div>

              <div className="flex min-w-0 flex-col items-center gap-2">
                <img src={luggage} alt="Luggage Capacity" className="h-8 w-8 object-contain" />
                <p className="text-[#555555] text-sm">{data.luggageCapacity}</p>
              </div>

              <div className="flex min-w-0 flex-col items-center gap-2">
                <img src={door} alt="No. of Doors" className="h-8 w-8 object-contain" />
                <p className="text-[#555555] text-sm">{data.noOfDoors}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default VehicleService;
